import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntro from "./HeaderIntro";
import NewsLetter from "./NewsLetter";
export class GstRegistration extends Component {
  render() {
    return (
      <div>
        <Header />
        <HeaderIntro />

        <section id="about" style={{ backgroundColor: "#f3f9fd" }}>
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>GST Registration Online - An Overview</h3>
              <p>
                An average person spends 8 hours a month behind GST compliances.
                With the latest changes in GST the process has become a bit
                confusing for many people out there. Moreover delay in the
                filing of GST return results in heavy penalties. Cliptax
                entangles you from all the worries regarding your GST filing and
                assists you with a complete solution to all your GST needs. We
                provide complete end-to-end solutions for every type of
                business/ profession. Your return will be prepared and filed by
                our in-house professional CA team having vast experience. We
                ensure you to submit your GST return without any delay. Our aim
                is to provide you our best services and we will help you with
                all the information to your queries.
              </p>
            </header>
          </div>
        </section>

        <section id="why-us" style={{ backgroundColor: "#f3f9fd" }}>
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>How Does GST Registration Work For You?</h3>
              <p>
                Any business offering sale of goods with annual turn over of 40
                lacs or service with annual turn over of 20 lacs would require
                the registration for GST and have a valid GST Number.
              </p>
            </header>

            <div class="row row-eq-height justify-content-center">
              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="100">
                  {/* <i class="fa fa-diamond"></i> */}
                  <div class="card-body">
                    <h5 class="card-title">Step 1</h5>
                    <p class="card-text">
                      We help you get a Secure GST Identification Number.
                    </p>
                    {/* <a href="#" class="readmore">
                      Read more{" "}
                    </a> */}
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="200">
                  {/* <i class="fa fa-language"></i> */}
                  <div class="card-body">
                    <h5 class="card-title">Step 2</h5>
                    <p class="card-text">
                      We make it easy for you to get your GST from the comfort
                      of your own home.
                    </p>
                    {/* <a href="#" class="readmore">
                      Read more{" "}
                    </a> */}
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="300">
                  {/* <i class="fa fa-object-group"></i> */}
                  <div class="card-body">
                    <h5 class="card-title">Step 3</h5>
                    <p class="card-text">
                      We will file your returns and complete all other
                      compliances as and when required{" "}
                    </p>
                    {/* <a href="#" class="readmore">
                      Read more{" "}
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <NewsLetter/>
        <Footer />
      </div>
    );
  }
}

export default GstRegistration;
